<template>
  <div>
    <b-card style="margin:auto;padding: 0px 0px 0px 0px;border:none;">
      <form
        name="contact-form"
        method="post"
        enctype="multipart/form-data"
        v-on:submit.prevent="handleSubmit"
        action="/success/"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
      >
        <input type="hidden" name="contact-form" value="contact" />
        <p hidden>
          <label>
            Don’t fill this out:
            <input name="bot-field" />
          </label>
        </p>
        <div class="input-contents">
          <div class="form-left col-xl-6 col-sm-12">
            <div class="sender-info">
              <div>
                <label for="name">Your Name</label>

                <b-form-group
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-for="nested-street"
                  for="name"
                  class="label"
                  style="margin-bottom:-14px;"
                ></b-form-group>
                <b-form-input id="nested-street" type="text" name="name" v-model="formData.name" />
              </div>
              <div>
                <label for="email">Email</label>
                <b-form-group
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-for="nested-street"
                  class="label"
                  for="email"
                  style="margin-bottom:-14px;"
                ></b-form-group>
                <b-form-input type="email" name="email" v-model="formData.email" />
              </div>
              <div>
                <label for="name">Your phone number</label>

                <b-form-group
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-for="nested-street"
                  for="phone"
                  class="label"
                  style="margin-bottom:-14px;"
                ></b-form-group>
                <b-form-input id="nested-street" type="text" name="phone" v-model="formData.phone" />
              </div>
              <div>
                <label for="name">Which property were you interested in?</label>

                <b-form-group
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-for="nested-street"
                  for="property"
                  class="label"
                  style="margin-bottom:-14px;"
                ></b-form-group>
                <b-form-input id="nested-street" type="text" name="property" v-model="formData.property" />
              </div>
            </div>
          </div>
          <!-- <div class="col-1"></div> -->
          <div class="form-right col-xl-6 col-sm-12">
            <div class="message-wrapper">
              <label for="message">Message</label>
              <b-form-textarea
                id="textarea"
                placeholder
                rows="12"
                max-rows="12"
                name="message"
                v-model="formData.message"
              ></b-form-textarea>
            </div>
          </div>
        </div>

        <b-button class="submit" variant="primary" type="submit">Submit</b-button>
      </form>
    </b-card>
  </div>
</template>
<script>
export default {
  name: "QAForm",
  data() {
    return {
      formData: {}
    };
  },
  methods: {
    encode(data) {
      return Object.keys(data)
        .map(
          key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
        )
        .join("&");
    },
    //This will submit the form data to Netlify, using their event system. Form data forwarding is set up within the Netlify dashboard.
    handleSubmit(e) {
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: this.encode({
          "form-name": e.target.getAttribute("name"),
          ...this.formData
        })
      })
        .then(() => this.$router.push("/success"))
        .catch(() => this.$router.push("/404"));
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  font-weight: 800;
  padding: 10px 20px 10px 20px;
  background-color: #2979ff;
  border-color: #2979ff;
}
#textarea {
  background-color: #f1f9ff;
  border: solid 1px #bce0fd;
}
input {
  background-color: #f1f9ff;
}
.submit {
  margin-top: 40px;
}
.form-left {
  text-align: left;
  label {
    margin-top: 20px;
    color: #2699fb;
    font-weight: 800;
  }
}
.form-right {
  text-align: left;
  margin-top: 20px;
  label {
    color: #2699fb;
    font-weight: 800;
  }
}

@media only screen and (min-width: 1201px) {
 .input-contents {
  display: flex;
  justify-content: space-between;
}
}
</style>